import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CommonResponse } from 'src/app/models/commonResponse';
import { ExportCsvResponse } from 'src/app/models/exportCsvResponst';
import { Order } from 'src/app/models/order';
import { OrderDetail } from 'src/app/models/orderDetail';
import { orderToDriver, orderUpdatePayload } from 'src/app/models/orderPayload';
import { OrderResponse } from 'src/app/models/orderResponse';
import { ReturnOrder } from 'src/app/models/returnOrder';
import { TeamResponse } from 'src/app/models/teamResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  constructor(private http: HttpClient) {}

  getOrder(query: string): Observable<OrderResponse> {
    return this.http
      .get<{
        data: OrderResponse;
      }>(`${environment.base_url}/vendor/getOrders?${query}`)
      .pipe(map(res => res.data));
  }

  getTeams(): Observable<Array<TeamResponse>> {
    return this.http
      .get<{
        data: Array<TeamResponse>;
      }>(`${environment.base_url}/vendor/teamsDropdown`)
      .pipe(map(res => res.data));
  }

  getOrderById(id: string): Observable<OrderDetail> {
    return this.http
      .get<{
        data: OrderDetail;
      }>(`${environment.base_url}/vendor/getDetailsByOrderId/${id}`)
      .pipe(map(res => res.data));
  }

  updateOrder(
    orderId: string,
    body: orderUpdatePayload
  ): Observable<OrderDetail> {
    return this.http
      .put<{
        data: OrderDetail;
      }>(`${environment.operational_url}updateOrder/${orderId}`, body)
      .pipe(map(res => res.data));
  }

  productsAgainstExchange(id: string): Observable<OrderDetail> {
    return this.http
      .get<{
        data: OrderDetail;
      }>(`${environment.base_url}/vendor/productsAgainstExchange/${id}`)
      .pipe(map(res => res.data));
  }

  getOrderForExchangeReturn(query: string): Observable<OrderResponse> {
    return this.http
      .get<{
        data: OrderResponse;
      }>(`${environment.base_url}/vendor/exchangeReturnDispatcher?${query}`)
      .pipe(map(res => res.data));
  }

  updateReturnOrder(payload: ReturnOrder): Observable<Order> {
    return this.http
      .put<{
        data: Order;
      }>(`${environment.base_url}/vendor/updateReturnOrder`, payload)
      .pipe(map(res => res.data));
  }

  updateExchangeOrder(payload: ReturnOrder): Observable<Order> {
    return this.http
      .put<{
        data: Order;
      }>(`${environment.base_url}/vendor/updateExchangeOrder`, payload)
      .pipe(map(res => res.data));
  }

  assignOrderToDriver(
    payload: orderToDriver,
    orderId: string
  ): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}/vendor/assignDriver/${orderId}`,
      payload
    );
  }

  exportCsv(orderStatus: number): Observable<ExportCsvResponse> {
    return this.http.get<ExportCsvResponse>(
      `${environment.base_url}/vendor/getOrdersDispatcherCSV?status=${orderStatus}`
    );
  }

  getInvoice(orderId: string): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(
      `${environment.operational_url}invoice/${orderId}`
    );
  }

  assignDriver(
    orderId: string,
    body: { driverId: string; bookingForReturnDriver?: boolean }
  ): Observable<CommonResponse> {
    return this.http
      .post<{
        data: CommonResponse;
      }>(`${environment.operational_url}assignOrder/${orderId}`, body)
      .pipe(map(res => res.data));
  }

  getDriversByTeam(id: string): Observable<{ data: Array<any> }> {
    return this.http.get<{ data: Array<any> }>(
      `${environment.base_url}driversThroughTeam/${id}`
    );
  }
}
